import { IConfiguredHttp } from './http';

export interface IAirbnbLinkingInput {
	ownerIds: Array<{ id: string }>;
}

enum ExecutionType {
	SYNC = 'sync',
	ASYNC = 'async',
}

enum StateMachineIdentifier {
	AIRBNB_LINKING = 'AIRBNB_LINKING',
	AIRBNB_MIGRATE = 'AIRBNB_MIGRATE_HOST',
}

interface IExecuteStateMachineBody {
	input: IAirbnbLinkingInput;
	executionType: ExecutionType;
	stateMachineIdentifier: StateMachineIdentifier;
}

export interface IAdminStateMachineApi {
	executeAirbnbLinking: (input: IAirbnbLinkingInput) => Promise<unknown>;
	executeAirbnbMigration: (input: IAirbnbLinkingInput) => Promise<unknown>;
}

const adminStateMachineApiFactory = (
	http: IConfiguredHttp,
	url = ''
): IAdminStateMachineApi => ({
	executeAirbnbLinking(input: IAirbnbLinkingInput) {
		return http.post(`${url}/executeStateMachine`, {
			input,
			executionType: ExecutionType.ASYNC,
			stateMachineIdentifier: StateMachineIdentifier.AIRBNB_LINKING,
		} as IExecuteStateMachineBody);
	},
	executeAirbnbMigration(input: IAirbnbLinkingInput) {
		return http.post(`${url}/executeStateMachine`, {
			input,
			executionType: ExecutionType.ASYNC,
			stateMachineIdentifier: StateMachineIdentifier.AIRBNB_MIGRATE,
		} as IExecuteStateMachineBody);
	},
});

export default adminStateMachineApiFactory;
